import { MAX_INVOICE_DISCOUNT_PERCENT } from '../constants/maxInvoiceDiscountPercent'
import { InvoiceDiscountType } from '../enums/invoiceDiscountType'
import { isPercentageDiscountType } from './isPercentageDiscountType'

export const clampInvoiceDiscountValue = (discount: number, discountType: InvoiceDiscountType): number =>
  isPercentageDiscountType(discountType) ? Math.min(discount, MAX_INVOICE_DISCOUNT_PERCENT) : discount
